(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["origami-site-footer"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.origamiCookiePreferencesBound) return;
  window.origamiCookiePreferencesBound = true;
  let loading;
  const getBanner = () => window.privacyBanner;
  function loadBanner() {
    if (typeof getBanner()?.showPreferences === 'function') return Promise.resolve(getBanner());
    if (loading) return loading;
    loading = new Promise((resolve, reject) => {
      let settled = false;
      let script = document.querySelector('script[src*="/shopifycloud/privacy-banner/privacy-banner.js"]');
      const finish = () => {
        if (settled) return;
        settled = true;
        clearTimeout(timer);
        if (typeof getBanner()?.showPreferences === 'function') resolve(getBanner());
        else reject(new Error('Cookie preferences unavailable'));
      };
      const timer = setTimeout(finish, 7000);
      if (!script) {
        script = document.createElement('script');
        script.src = '/cdn/shopifycloud/privacy-banner/privacy-banner.js';
        script.async = true;
        script.addEventListener('load', finish, { once: true });
        script.addEventListener('error', finish, { once: true });
        document.head.appendChild(script);
      } else {
        script.addEventListener('load', finish, { once: true });
        script.addEventListener('error', finish, { once: true });
      }
    }).catch(error => { loading = undefined; throw error; });
    return loading;
  }
  document.addEventListener('click', event => {
    const link = event.target.closest?.('[data-og-cookie-preferences]');
    if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    if (link.getAttribute('aria-busy') === 'true') return;
    link.setAttribute('aria-busy', 'true');
    loadBanner().then(banner => banner.showPreferences()).catch(() => {
      window.location.assign(link.href);
    }).finally(() => link.removeAttribute('aria-busy'));
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["origami-site-header"] && !Shopify.designMode) return;
  try {
    (() => {
  const positionMenu = menu => {
    const panel=menu.querySelector('.og-mobile-panel');
    const header=menu.closest('.og-header');
    if(!panel || !header) return;
    const top=Math.max(12,Math.min(header.getBoundingClientRect().bottom+12,window.innerHeight-160));
    panel.style.setProperty('--og-menu-top',top+'px');
  };
  const repositionOpen = () => document.querySelectorAll('.og-header-menu[open]').forEach(positionMenu);
  document.addEventListener('keydown',event=>{if(event.key!=='Escape')return;const menu=document.querySelector('.og-header-menu[open]');if(menu){menu.open=false;menu.querySelector('summary').focus();}});
  document.addEventListener('toggle',event=>{if(event.target.matches?.('.og-header-menu')){event.target.querySelector('summary').setAttribute('aria-expanded',String(event.target.open));if(event.target.open)positionMenu(event.target);}},true);
  document.addEventListener('click',event=>{
    document.querySelectorAll('.og-header-menu[open]').forEach(menu=>{if(!menu.contains(event.target)||event.target.matches('.og-menu-backdrop')){menu.open=false;if(event.target.matches('.og-menu-backdrop'))menu.querySelector('summary').focus();}});
    const link=event.target.closest?.('[data-og-native-cart]');
    if(!link || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button!==0)return;
    const drawer=document.querySelector('cart-drawer-component');
    if(typeof drawer?.open==='function'){event.preventDefault();drawer.open();}
  });
  window.addEventListener('resize',repositionOpen,{passive:true});
  window.addEventListener('scroll',repositionOpen,{passive:true});
})();
  } catch(e) { console.error(e); }
})();

})();
